export class TabelaHorarioTableDTO {

    qtdTabelaHorario: number;
    cdConcessionario: number;
    nmPessoa: string;
    qtdRotas: number;
    nrLinha: string;
    cdLinha: number;
    stLinha: number;
    tpLinha: number;

    constructor(
        qtdTabelaHorario?: number,
        cdConcessionario?: number,
        nmPessoa?: string,
        qtdRotas?: number,
        nrLinha?: string,
        cdLinha?: number,
        stLinha?: number,
        tpLinha?: number
    ) {
        this.qtdTabelaHorario = qtdTabelaHorario;
        this.cdConcessionario = cdConcessionario;
        this.nmPessoa = nmPessoa;
        this.qtdRotas = qtdRotas;
        this.nrLinha = nrLinha;
        this.cdLinha = cdLinha;
        this.stLinha = stLinha;
        this.tpLinha = tpLinha;
    }
}

export class TabelaHorarioTableDTOList {
    items: Array<TabelaHorarioTableDTO>;
    total: number;

    constructor() {}
}